export const state = () => ({
  errors: [],
})

export const getters = {
  getAll: state => {
    return state.errors
  },
  getCount: state => {
    return state.errors.length
  },
  getFirst: state => input => {
    if (typeof state.errors[input] !== 'undefined') {
      return state.errors[input][0]
    }

    return null
  },
  exists: state => input => {
    return typeof state.errors[input] !== 'undefined'
  },
}

export const mutations = {
  SET_ERRORS(state, errors) {
    state.errors = errors
  },
  REMOVE_ERROR(state, input) {
    if (typeof state.errors[input] !== 'undefined') {
      delete state.errors[input]
    }
  },
}

export const actions = {
  clearErrors({ commit, getters }) {
    let errors = getters['getAll']

    for (let error in errors) {
      commit('REMOVE_ERROR', error)
    }
  },
}
